import React, { Component } from 'react';
import Select, { createFilter } from 'react-select';
import { isMobile } from 'react-device-detect';

export class BrandFilter extends Component {
    constructor(props) {
        super(props);

        this.filterConfig = {
            matchFrom: 'start'
        }
    }

    render() {
        return (
            this.props.loading
                ? <Select isLoading={true} />
                : <Select
                    name={this.props.name}
                    options={this.props.options}
                    value={this.props.value}
                    isSearchable={!isMobile}
                    onChange={this.props.onChange}
                    filterOption={createFilter(this.filterConfig)}
                    placeholder="Velg merke" />
        )
    }
}
